import FootballState from "../../../../state/football-state";
import RushTouchdownStats from "../../../offensive/rush/rush-touchdown-stats";

export default class FieldGoalFakeRunTouchdownStats extends RushTouchdownStats {
    // eslint-disable-next-line no-unused-vars
    applicable(
        gameContext,
        ruleContext,
        eventConfiguration,
        { play, fragment }
    ) {
        return fragment.associatedState === FootballState.FieldGoalFakeRun;
    }
}
